<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <form id="FormGaleriaA" role="form" method="post" autocomplete="off" onSubmit="return false">
                <div v-show="!MostrarDetalle" id="div-3">
                    <div class="row g-3">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
                            <div class="search mb-2 cursor-pointer">
                                <input type="text" v-model="FiltroCategoria" @input="BuscarCategoria();" class="form-control">
                                <button type="button" v-show="(FiltroCategoria!='')" @click="BorrarBusquedaCategoria();" class="btn bt-sm btn-success">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>

                            <div class="nav nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                <div v-for="(item,index) in ListaCategorias" :key="index" class="d-grid gap-2 col-12">
                                    <button type="button" @click="GetListGaleria(item.IdCategoriaGaleria,index);" :class="['nav-link',(index == 0) ? 'active': '']" :id="'v-pills-C'+index+'-tab'" data-bs-toggle="pill" :data-bs-target="'#v-pills-C'+index" role="tab" :aria-controls="'v-pills-C'+index" :aria-selected="(index == 0)? 'true': 'false'">
                                        {{item.Categoria}}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
                            <div class="tab-content" id="v-pills-tabContent">
                                <div class="tab-pane fade show active" :id="'v-pills-'+IndexActivo" role="tabpanel" :aria-labelledby="'v-pills-C'+IndexActivo+'-tab'" tabindex="0">
                                    <CLoader :pConfigLoad="ConfigLoadTab">
                                    <template slot="BodyFormLoad">

                                    <div class="row g-3">
                                        <div v-for="(item,index) in ListaGaleria" :key="index" class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 mb-1">
                                            <figure class="figure position-relative">
                                                <label :for="'checkbox_'+index" class="m-0">
                                                    <span v-if="!item.Nomimagen">
                                                        <img src="@/assets/style/image/sin_imagen_200.jpg" class="figure-img img-fluid mx-auto  rounded" alt="..." >
                                                    </span>

                                                    <span v-else>
                                                        <img :src="RutaFile+item.UrlImagen+item.Nomimagen" class="figure-img img-fluid rounded" alt="..." style="width: 200px; height: 200px; object-fit: cover;" >
                                                    </span>
                                                </label>

                                                <figcaption class="figure-caption text-center">
                                                    {{$formatNumber(item.Precio,'$')}} <br>
                                                    {{$limitCharacters(item.Descripcion,110)}}
                                                </figcaption>
                                                <!-- <figcaption class="figure-caption text-center">Disponibles: {{item.Restante!=undefined ? item.Restante : item.Stock}}</figcaption> -->

                                                <div class="form-check galeria-check">
                                                    <input type="checkbox" v-model="item.Check" @change="AgregarItem(item)" :id="'checkbox_'+index" class="form-check-input" value="true">
                                                </div>
                                            </figure>
                                        </div>
                                    </div>

                                    </template>
                                    </CLoader>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                    
                <div v-show="MostrarDetalle" id="div-4">

                    <div class="row g-3">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <table class="table mb-0">
                                <thead>
                                    <tr>
                                        <th class="text-green-black text-xxs font-weight-bolder opacity-7">#</th>
                                        <th class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7">Imagen</th>
                                        <th class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7">Descripción</th>
                                        <th class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7">Cantidad</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in ListaSeleccionados" :key="index">
                                        <td class="align-middle text-center" style="width: 10px;">
                                            <h6 class="mb-0 text-sm text-capitalize ps-3">{{(index+1)}}</h6>
                                        </td>
                                        <td class="align-middle text-center" style="width: 120px;">
                                            <span v-if="!item.Nomimagen">
                                                <img src="@/assets/style/image/sin_imagen_180.jpg" class="img-fluid rounded">
                                            </span>

                                            <span v-else>
                                                <img :src="RutaFile+item.UrlImagen+item.Nomimagen" class="img-fluid rounded">
                                            </span>
                                        </td>
                                        <td class="align-middle ps-3">                                           

                                            <div class="btn-group mb-0" role="group" aria-label="basic">
                                                <button type="button" @click="GetEstiloCampo(item,'ESP');" :class="{'btn btn-sm btn-outline-primary mb-0' :item.EstiloEsp, 'btn btn-sm btn-primary btn-nav-group mb-0' :!item.EstiloEsp}">
                                                    <i class="far fa-language"></i> Español
                                                </button>

                                                <button type="button" @click="GetEstiloCampo(item,'ING');" :class="{'btn btn-sm btn-outline-primary mb-0' : item.EstiloIng, 'btn btn-sm btn-primary btn-nav-group mb-0' :!item.EstiloIng}">
                                                    <i class="far fa-language"></i> Ingles
                                                </button>

                                                <button type="button" @click="GetEstiloCampo(item,'NOT');" :class="{'btn btn-sm btn-outline-primary mb-0' :item.EstiloNot, 'btn btn-sm btn-primary btn-nav-group mb-0' :!item.EstiloNot}">
                                                    <i class="fas fa-sticky-note"></i> Nota
                                                </button>
                                            </div>

                                            <textarea v-show="item.EstiloEsp" v-model="item.Descripcion" class="form-control mt-1" rows="2"></textarea>
                                            <textarea v-show="item.EstiloIng" v-model="item.DescripcionIngles" class="form-control mt-1" rows="2"></textarea>
                                            <textarea v-show="item.EstiloNot" v-model="item.Notas" class="form-control mt-1" rows="2"></textarea>
                                        </td>

                                        <td class="align-middle">
                                            <input type="text" v-model="item.Cantidad" @input="$onlyNums($event,item,'Cantidad');" class="form-control form-control-sm">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                 
                </div>
                <br>
            </form>
		</template>
	</CLoader>
</template>

<script>
import moment from 'moment';
export default {
    name: 'FormGaleria',
    props: ['poBtnSave','pFechaEvento'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            ConfigLoadTab:{
                ShowLoader: false,
                ClassLoad: false,
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
            ListaCategorias: [],
            ListaGaleria: [],
            CategoriasActivas: [],
            ListaSeleccionados: [],
            MostrarDetalle: false,
            FiltroCategoria: '',
            TimeOutSearch: null,
            IndexActivo: 0,
            RutaFile: '',
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

            if(this.ListaSeleccionados.length == 0){
                this.$toast.warning('Debe seleccionar al menos un item de la galeria');
                this.poBtnSave.DisableBtn = false;
                return false;
            }

            let band1 = 0;
            let msg1 = '';

			$.each(this.ListaSeleccionados, function(key, value){
                if(value.Descripcion == ''){
                    msg1 = "El campo Descripción en español de la partida: "+(key+1)+" no puede estar vacio";
                    band1++;
                    return false;
                }
                else if(value.DescripcionIngles == ''){
                    msg1 = "El campo Descripción en ingles de la partida: "+(key+1)+" no puede estar vacio";
                    band1++;
                    return false;
                }
                else if(value.Cantidad == ''){
                    msg1 = "El campo Cantidad de la partida: "+(key+1)+" no puede estar vacio";
                    band1++;
                    return false;
                }
            });
            if(band1>0){ this.$toast.warning(msg1); this.poBtnSave.DisableBtn = false; return false; }

            this.poBtnSave.DisableBtn = false;
            this.bus.$emit('SetearGaleria',this.ListaSeleccionados);
            this.bus.$emit('CloseModal_'+this.Emit);
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Limpiar()
        {
            this.errorvalidacion = [];
            this.ListaCategorias = [];
            this.ListaGaleria = [];
        },
        async GetListCategorias()
		{
			await this.$http.get('categoriasGaleria', {
				params:{
					simple: 1,
                    EstatusAct: 1,
				}
			}).then( (res) => {
                let Categorias = res.data.data;

                this.ListaCategorias = Categorias;
                this.CategoriasActivas = Categorias;

			}).finally(()=>{
                //this.ConfigLoad.ShowLoader = false;
                if(this.ListaCategorias.length>0){
                    let IdCategoria = this.ListaCategorias[0].IdCategoriaGaleria;
                    this.GetListGaleria(IdCategoria,0);
                }
            });
		},
        GetListGaleria(IdCategoria,Index)
        {
            let Fecha='';
            if (this.pFechaEvento!=undefined) {
                Fecha = moment(this.pFechaEvento).format('YYYY-MM-DD');
            }
            this.IndexActivo = Index;
            if(this.ConfigLoad.ShowLoader == false){
                this.ConfigLoadTab.ShowLoader = true;
            }
            let IdCotz = sessionStorage.getItem('IdCotizacion');

            if(IdCategoria !=0)
            {
                this.ListaGaleria = [];
                this.$http.get('bancoImagenesComision', {
                    params:{
                        IdCategoriaGaleria: IdCategoria,
                        simple: 1,
                        Cotizacion:1,
                        FechaEvento:Fecha,
                        IdCotz: IdCotz,
                    }
                }).then( (res) => {
                    let arreglo = res.data.data;
                    this.RutaFile = res.data.RutaFile;

                    arreglo.map((element)=>{
                        element.IdDetalleCotizacion = 0;
                        element.IdCotizacionEvento = 0;
                        element.IdImagenCopia   = 0;
                        element.DescripcionIngles = element.DescripcionIng;
                        element.Notas           = '';
                        element.TotalIndividual = '';
                        element.Moneda          = '';
                        element.Anexado         = 0;
                        element.TipoMoneda      = 'MXN';
                        element.FYM             = '';
                        element.EstiloIng       = false;
                        element.EstiloEsp       = true;
                        element.EstiloNot       = false;
                        element.Cantidad        = '';
                        element.Check           = false;
                        element.UrlImagen       = element.UrlImagen;
                    });

                    if(arreglo.length>0)
                    {
                        arreglo.forEach((value, index) => {
                            const validaExist = this.ListaSeleccionados.filter(function(item){
                                if(item.IdBancoImagen == value.IdBancoImagen){
                                    return item;
                                } else {
                                    return '';
                                }
                            });

                            value.Check = false;

                            if(validaExist[0]){
                                value.Check = true;
                            }
                        });

                        this.ListaGaleria = arreglo;
                    }

                }).finally(()=>{
                    this.ConfigLoad.ShowLoader = false;
                    this.ConfigLoadTab.ShowLoader = false;
                });
            }
            else
            {
                this.ListaGaleria = [];
                this.ConfigLoad.ShowLoader = false;
                this.ConfigLoadTab.ShowLoader = false;
            }
        },
        BuscarCategoria()
        {
            clearTimeout(this.TimeOutSearch);
            //this.IconoSearchLig = spiner;

            this.TimeOutSearch = setTimeout(() => {
                this.EjecutarBusqueda();
            }, 1000);
        },
        EjecutarBusqueda()
        {
            if(this.FiltroCategoria!='')
            {
                let Buscar = this.FiltroCategoria;
                let Busqueda = this.CategoriasActivas.filter(element => {
                    return element.Categoria.toUpperCase().includes(Buscar.toUpperCase());
                });

                this.ListaCategorias = Busqueda;
            }
            else
            {
                this.ListaCategorias = this.CategoriasActivas;
            }
        },
        BorrarBusquedaCategoria()
        {
            this.FiltroCategoria = '';
            this.ListaCategorias = this.CategoriasActivas;
        },
        AgregarItem(item)
        {
            if(item.Check == true)
            {
                this.ListaSeleccionados.push(item);
            }
            else
            {
                let Buscar = item.IdBancoImagen;
                let Arreglo = this.ListaSeleccionados;
                let arregloActual = Arreglo.filter((element) =>{
                    if(element.IdBancoImagen != Buscar){
                        return element;
                    }
                });

                this.ListaSeleccionados = arregloActual;
            }
        },
        OcultarDetalle()
        {
            if(this.MostrarDetalle == false){
                this.MostrarDetalle = true;
                //this.bus.$emit('HideFooter_'+this.Emit,false);
                this.poBtnSave.ShowBtnCancel = true;
				this.poBtnSave.ShowBtnSave = true;
            }else{
                this.MostrarDetalle = false;
                //this.bus.$emit('HideFooter_'+this.Emit,true);
                this.poBtnSave.ShowBtnCancel = false;
				this.poBtnSave.ShowBtnSave = false;
            }
        },
        GetEstiloCampo(item,Campo)
        {
            let EsA = false;
            let EsB = false;
            let EsC = false;

            switch(Campo)
            {
                case 'ESP':
                    EsA = true;
                break;

                case 'ING':
                    EsB = true;
                break;

                case 'NOT':
                    EsC = true;
                break;
            }

            item.EstiloEsp = EsA;
            item.EstiloIng = EsB;
            item.EstiloNot = EsC;
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            
            this.Limpiar();
            //this.bus.$emit('HideFooter_'+this.Emit,true);
            this.poBtnSave.ShowBtnCancel = false;
            this.poBtnSave.ShowBtnSave = false;
            this.bus.$emit('ResetearVistaGal');

            this.GetListCategorias();
                

            this.bus.$off('CambiarVistaGal');
            this.bus.$on('CambiarVistaGal',()=>
            {
                this.OcultarDetalle();
            });
        });
    },
    computed: {
       
    },
    watch: {
       
    },
}
</script>
